import { RootState } from "@/store/store";
import { AlertCircle, Modal } from "@ews-admin/global-design-system";
import React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { clearError } from "../../store/reducers/errorSlice";

export const ErrorModal: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const errorData = useSelector((state: RootState) => state.error.error);

  const handleClose = () => {
    dispatch(clearError());
  };

  if (!errorData) {
    return null;
  }

  const errorCode = errorData.code;
  const hasTranslation = errorCode && t(`error.${errorCode}.title`) !== `error.${errorCode}.title`;

  const title = hasTranslation
    ? t(`error.${errorCode}.title`)
    : t("common.errors.title");

  const description = hasTranslation
    ? t(`error.${errorCode}.description`)
    : t("common.errors.subtitle");

  return createPortal(
    <div style={{ position: "relative", zIndex: 9999 }}>
      <Modal
        isOpen={true}
        onClose={handleClose}
        title={title}
        variant="error"
        primaryAction={t("common.errors.close")}
        onPrimaryAction={handleClose}
      >
        <div className="space-y-4">
          {/* Main error message */}
          <p className="text-neutral-700">{description}</p>

          {/* Field errors */}
          {errorData.fields && errorData.fields.length > 0 && (
            <div className="mt-4">
              <h4 className="mb-2 text-sm font-semibold text-neutral-900">
                {t("error.fieldErrors", t("common.errors.fieldErrors"))}
              </h4>
              <ul className="space-y-2">
                {errorData.fields.map((field, index) => (
                  <li key={index} className="flex items-start space-x-2">
                    <AlertCircle className="w-4 h-4 text-error-500 mt-0.5 flex-shrink-0" />
                    <span className="text-sm text-neutral-700">
                      <span className="font-medium">{field.name}:</span>{" "}
                      {field.message || t("common.errors.invalidField")}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Modal>
    </div>,
    document.body
  );
};
